<ng-container *ngIf="permConfig.isAddAllowed">
    <div class="container-fluid">
        <app-page-title title="Add Taxes"></app-page-title>
        <form [formGroup]="taxesForm" (ngSubmit)="addTaxes()"
            (keydown.enter)="useEnterKey ? $event.preventDefault() : addTaxes()">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="rateType" class="form-label">Rate Type <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="rateType" placeholder="Select" [items]="rateTypeList"
                                            [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlRateType"
                                            bindLabel="ratetype" [bindValue]="'id'" (change)="onChangeRateType()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('ddlRateType').dirty) && taxesForm.get('ddlRateType').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || taxesForm.get('ddlRateType').dirty) && taxesForm.get('ddlRateType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesForm.get('ddlRateType').errors.required">Rate Type is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2" *ngIf="showCategory">
                                    <div class="mb-2">
                                        <label for="rateCategoryType" class="form-label">Category </label>
                                        <ng-select id="rateCategoryType" placeholder="Select"
                                            [items]="rateCategoriesList" [appendTo]="'body'" [openOnEnter]="false"
                                            formControlName="ddlRateCategory" bindLabel="ratecategory"
                                            [bindValue]="'id'" (change)="onChangeRateCategory()"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('ddlRateCategory').touched) && taxesForm.get('ddlRateCategory').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || taxesForm.get('ddlRateCategory').touched) && taxesForm.get('ddlRateCategory').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesForm.get('ddlRateCategory').errors.required">Category is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="fromDate" class="form-label">From Date <span
                                                class="mandatory">*</span></label>
                                        <input id="fromDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtFromDate"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('txtFromDate').touched) && taxesForm.get('txtFromDate').errors}">
                                        <div *ngIf="(isFormSubmitted || taxesForm.get('txtFromDate').touched) && taxesForm.get('txtFromDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesForm.get('txtFromDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="toDate" class="form-label">To Date <span
                                                class="mandatory">*</span></label>
                                        <input id="toDate" class="form-control form-control-sm" type="date"
                                            formControlName="txtToDate"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('txtToDate').touched) && taxesForm.get('txtToDate').errors}">
                                        <div *ngIf="(isFormSubmitted || taxesForm.get('txtToDate').touched) && taxesForm.get('txtToDate').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesForm.get('txtToDate').errors.required">Date is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                                <ng-container *ngIf="showBands">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="rateBands" class="form-label">Rate Bands <span
                                                    class="mandatory">*</span></label>
                                            <ng-select id="rateBands" [items]="rateBandList" bindLabel="rateband"
                                                placeholder="Select" [bindValue]="'id'" [appendTo]="'body'"
                                                [openOnEnter]="false" formControlName="ddlRateBand"
                                                [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('ddlRateBand').touched) && taxesForm.get('ddlRateBand').errors}">
                                            </ng-select>
                                            <div *ngIf="(isFormSubmitted || taxesForm.get('ddlRateBand').touched) && taxesForm.get('ddlRateBand').errors"
                                                class="invalid-feedback">
                                                <span *ngIf="taxesForm.get('ddlRateBand').errors.required">Rate Band is
                                                    Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="showCustomer">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="customerRate" class="form-label">Customer <span
                                                    class="mandatory">*</span></label>
                                            <ng-select id="customerRate" [items]="customerList" bindLabel="name"
                                                placeholder="Select" [bindValue]="'id'" [appendTo]="'body'"
                                                [openOnEnter]="false" formControlName="ddlCustomer"
                                                [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('ddlCustomer').touched) && taxesForm.get('ddlCustomer').errors}">
                                            </ng-select>
                                            <div *ngIf="(isFormSubmitted || taxesForm.get('ddlCustomer').touched) && taxesForm.get('ddlCustomer').errors"
                                                class="invalid-feedback">
                                                <span *ngIf="taxesForm.get('ddlCustomer').errors.required">Customer is
                                                    Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="showVendor">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <label for="headerVendor" class="form-label">Vendor<span
                                                    class="mandatory">*</span></label>
                                            <ng-select id="headerVendor" [items]="vendorList" bindLabel="name"
                                                placeholder="Select" [bindValue]="'id'" [appendTo]="'body'"
                                                [openOnEnter]="false" formControlName="ddlVendor"
                                                [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('ddlVendor').touched) && taxesForm.get('ddlVendor').errors}">
                                            </ng-select>
                                            <div *ngIf="(isFormSubmitted || taxesForm.get('ddlVendor').touched) && taxesForm.get('ddlVendor').errors"
                                                class="invalid-feedback">
                                                <span *ngIf="taxesForm.get('ddlVendor').errors.required">Vendor is
                                                    Required</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="company" class="form-label">Company</label>
                                        <ng-select class="form-control form-control-sm" formControlName="ddlCompany"
                                            id="company" [items]="companyList" bindLabel="name" [bindValue]="'id'"
                                            placeholder="select" [appendTo]="'body'" [openOnEnter]="false"
                                            class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom">
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="product" class="form-label">Product</label>
                                        <ng-select id="product" [items]="productList" bindLabel="name"
                                            [bindValue]="'code'" placeholder="Select" [appendTo]="'body'"
                                            [openOnEnter]="false" formControlName="ddlProduct">
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="mb-2">
                                        <label for="igst" class="form-label">IGST %<span
                                                class="mandatory">*</span></label>
                                        <input type="number" class="form-control form-control-sm" id="igst"
                                            formControlName="txtIGST" appLimitDigits [length]="6"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('txtIGST').touched) && taxesForm.get('txtIGST').errors}">
                                        <div *ngIf="(isFormSubmitted || taxesForm.get('txtIGST').touched) && taxesForm.get('txtIGST').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesForm.get('txtIGST').errors.required">IGST is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="mb-2">
                                        <label for="cgst" class="form-label">CGST %<span
                                                class="mandatory">*</span></label>
                                        <input type="number" class="form-control form-control-sm" id="cgst"
                                            formControlName="txtCGST" appLimitDigits [length]="6"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('txtCGST').touched) && taxesForm.get('txtCGST').errors}">
                                        <div *ngIf="(isFormSubmitted || taxesForm.get('txtCGST').touched) && taxesForm.get('txtCGST').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesForm.get('txtCGST').errors.required">CGST is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="mb-2">
                                        <label for="sgst" class="form-label">SGST %<span
                                                class="mandatory">*</span></label>
                                        <input type="number" class="form-control form-control-sm" id="sgst"
                                            formControlName="txtSGST" appLimitDigits [length]="6"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || taxesForm.get('txtSGST').touched) && taxesForm.get('txtSGST').errors}">
                                        <div *ngIf="(isFormSubmitted || taxesForm.get('txtSGST').touched) && taxesForm.get('txtSGST').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="taxesForm.get('txtSGST').errors.required">SGST is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="button-items mb-2">
                        <button type="submit" class="btn btn-primary w-sm">Add</button>
                        <button type="button" class="btn btn-secondary w-sm" (click)="resetForm()">Clear</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Available Taxes</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                class="ag-theme-balham" [rowData]="rowData" [columnDefs]="columnDefs"
                                [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReady($event)"
                                [gridOptions]="gridOptions" [rowSelection]="'single'">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>